import { BUNDLE } from 'apps/auth/constants/EntryPoint';
import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';
import GTSendMultiPage from 'apps/auth/pages/send/GTSendMultiPage';

const authGlobalSend = [
    {
        path: '/auth/global/:deliveryMethod/send',
        exact: true,
        component: GTSendMultiPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            hideViewRatesFirst: true,
            globalFlow: true,
        },
    },
    {
        path: '/auth/global/repeat',
        exact: true,
        component: GTSendMultiPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: false,
            repeat: true,
            globalFlow: true,
        },
    },
];

export default authGlobalSend;
